import { render, staticRenderFns } from "./FranchiseeFormView.vue?vue&type=template&id=0bb56bc7&scoped=true"
import script from "./FranchiseeFormView.vue?vue&type=script&lang=ts"
export * from "./FranchiseeFormView.vue?vue&type=script&lang=ts"
import style0 from "./FranchiseeFormView.vue?vue&type=style&index=0&id=0bb56bc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb56bc7",
  null
  
)

export default component.exports